import { render, staticRenderFns } from "./TechPackage.vue?vue&type=template&id=219e7242&scoped=true&"
import script from "./TechPackage.vue?vue&type=script&lang=js&"
export * from "./TechPackage.vue?vue&type=script&lang=js&"
import style0 from "./TechPackage.vue?vue&type=style&index=0&id=219e7242&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219e7242",
  null
  
)

export default component.exports